import styled from 'styled-components';
import { Icon } from 'semantic-ui-react';

export const Container = styled.div`
  align-self: center;
  margin-left: 40px;
  width: 350px;
`;

export const TextNoResults = styled.p`
  color: #333333;
  font-size: 14px;
  font-family: Roboto;
`;

export const IconCaretDown = styled(Icon)`
`;
